import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import { formClasses } from '../../styles/formStyles';
import { Button, FormControl, Grid, TextField } from '@mui/material';
import { refundClientPayment } from 'services/refund.service';
import { useAppDispatch } from 'Stores/Hooks/hooks';
import { SEND_MESSAGE } from 'Stores/Slices/errorHandlingSlice';
import { CssTextField } from 'views/Common/CssTextField';


const PREFIX = 'RefundPaymentDialog';

const classes = {
    appBar: `${PREFIX}-appBar`,
    title: `${PREFIX}-title`,
    table: `${PREFIX}-table`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.appBar}`]: {
		position: 'relative',
	},

    [`& .${classes.title}`]: {
		marginLeft: theme.spacing(2),
		flex: 1,
	},

    [`& .${classes.table}`]: {
		minWidth: '250',
		minHeight: '500',
	}
}));

interface RefundPaymentDialogProps {
	showPaymentDialog: boolean;
	handleCloseModal: any;
	refundData: any;
}

type width = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
export default function RefundPaymentDialog(props: RefundPaymentDialogProps) {
	const { showPaymentDialog, handleCloseModal, refundData } = props;


	// const dispatch = useDispatch();
  const dispatch = useAppDispatch();
	const handleClose = () => {
		handleCloseModal();
	};
	const handleChange = (e: any) => {
		const {
			target: { value, name },
		} = e;

		if (name === 'paymentDescription') {
			setPaymentDescription(value);
		}
	};

	const handleProceed = async (status: string) => {
		const data = {
			status: status,
			notes: paymentDescription,
		};
		const refundId = refundData?.id;
		try {
			await refundClientPayment(refundId, data);
      dispatch(SEND_MESSAGE({ message: 'SUCCESSFULLY', type:'success'}));
			handleCloseModal();
		} catch (error:any) {
      dispatch(SEND_MESSAGE({ message: error, type:'error'}));

		}
	};
	const formStyles = formClasses();
	const [fullWidth] = React.useState(true);
	const [maxWidth] = React.useState<width>('lg');

	const [paymentDescription, setPaymentDescription] = useState('');
	return (
        <Root>
			<Dialog
				fullWidth={fullWidth}
				maxWidth={maxWidth}
				open={showPaymentDialog}
				onClose={handleClose}>
				<AppBar className={classes.appBar} style={{position:"unset",backgroundColor:"#042630"}}>
					<Toolbar>
						<IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                            size="large">
							<CloseIcon />
						</IconButton>
						<Typography variant="h6" className={classes.title}>
							Payment Details{' '}
						</Typography>
					</Toolbar>
				</AppBar>
				<Grid container>
					<Grid item xs={2}></Grid>
					<Grid item xs={8}>
						<Grid className={formStyles.subForm} xs={12}>
							<Grid item xs={6} className={formStyles.formElementGrid}>
								<Typography variant="subtitle1">
									{' '}
									Refund Amount: ₹ {refundData?.amount}{' '}
								</Typography>
							</Grid>
							<Grid item xs={6} className={formStyles.formElementGrid}>
								<Typography variant="subtitle1">
									{' '}
									Payment status: {refundData?.paymentStatus}{' '}
								</Typography>
							</Grid>
						</Grid>
						<Grid className={formStyles.subForm} xs={12}>
							<Grid item className={formStyles.formElementGrid}>
								<FormControl variant="outlined" fullWidth>
									<CssTextField
										id="outlined-multiline-static"
										label="Payment Description"
										multiline
										rows={4}
										defaultValue="Default Value"
										variant="outlined"
										value={paymentDescription}
										name="paymentDescription"
										onChange={handleChange}
									/>
								</FormControl>
							</Grid>
						</Grid>
						<Grid
							item
							className={formStyles.subForm}
							container
							xs={12}
							direction="row"
							justifyContent="space-around">
							<Button
								// color="primary"
                style={{color:"#042630",borderColor:"#042630"}}
								variant="outlined"
								onClick={() => handleProceed('Rejected')}>
								{' '}
								Not Received{' '}
							</Button>

							<Button
								// color="primary"
                style={{backgroundColor:"#042630",color:"#ffffff"}}
								variant="contained"
								onClick={() => handleProceed('Accepted')}>
								{' '}
								Received{' '}
							</Button>
						</Grid>
					</Grid>
					<Grid item xs={2}></Grid>
				</Grid>
			</Dialog>
		</Root>
    );
}
